import {Injectable} from '@angular/core';
import {createClient, Entry} from 'contentful';

const CONFIG = {
  space: 'u128j5s4q9gv',
  accessToken: '705bc912f826ae56ec190e64f06e368c53d32785a088d46247f506077065c15b',
};

@Injectable({
  providedIn: 'root'
})
export class ContentfulService {

  private cdaClient = createClient({
    space: CONFIG.space,
    accessToken: CONFIG.accessToken
  });

  constructor() {
  }

  getEntries(contentType: 'vendorsHelpCategory' | 'vendorsHelpArticle', query?: object): Promise<any> {
    return this.cdaClient.getEntries(Object.assign({
      content_type: contentType,
      order: '-sys.createdAt'
    }, query));
  }

  getEntry(slug: string, contentType: 'vendorsHelpCategory' | 'vendorsHelpArticle'): Promise<Entry<any>> {
    return this.cdaClient.getEntries(Object.assign({
      content_type: contentType
    }, {'fields.slug': slug})).then(res => res.items[0]);
  }
}
